import React, { useEffect, useState } from 'react'
import { Row } from 'react-bootstrap'
import { useHistory, withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { retrieveSingleClientDetails, retrieveSingleClientNotes, retrieveSingleClientRoles, retrieveSingleClientSales, resetUpdateSingleClientData, resetDeleteSingleClientData, resetDeleteSingleClientSale, resetSingleClientActiveSalesKey, resetSingleClientActiveSale, resetUpdateSingleClientSale, resetAddSingleClientNote, resetDeleteSingleClientNote, resetAddSingleClientSale, resetSingleClientDetails } from '../../../redux/actions/single-client'
import DashboardSingleClientRemoveModal from './modals/delete-client-modal'
import DashboardSingleClientEditModal from './modals/edit-client-modal'
import DashboardSingleClientRemoveSaleModal from './modals/delete-sale-modal'
import DashboardSingleClientNewSaleModal from './modals/new-sale-modal';
import ClientInformation from './client-information'
import ClientActivity from './client-activity'
import { sendErrorNotification, sendSuccessNotification } from '../../universal/notifications/notifications'
import { ToastContainer } from 'react-toastify'
import DashboardSingleClientEditSaleModal from './modals/edit-sale-modal'
import { setFallbackMessage } from '../../../redux/actions/universal'
import './style.scss'

const Index = props => {

	const dispatch = useDispatch()
	const history = useHistory()

	const clientId = props && props.match && props.match.params && props.match.params.id

	const modalState = useSelector(state => state.singleClient.showModals)
	const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
	const activeSelectionYear = useSelector(state => state.singleClient.activeSelectionYear)

	const updateError = useSelector(state => state.singleClient.updateDetails.error)
	const updateStatus = useSelector(state => state.singleClient.updateDetails.status)

	const deleteError = useSelector(state => state.singleClient.deleteClient.error)
	const deleteStatus = useSelector(state => state.singleClient.deleteClient.status)

	const addNoteStatus = useSelector(state => state.singleClient.addNote.status)
	const addNoteError = useSelector(state => state.singleClient.addNote.error)

	const deleteNoteStatus = useSelector(state => state.singleClient.removeNote.status)
	const deleteNoteError = useSelector(state => state.singleClient.removeNote.error)

	const addSaleStatus = useSelector(state => state.singleClient.addSale.status)
	const addSaleError = useSelector(state => state.singleClient.addSale.error)

	const deleteSaleStatus = useSelector(state => state.singleClient.deleteSale.status)
	const deleteSaleError = useSelector(state => state.singleClient.deleteSale.error)

	const updateSaleStatus = useSelector(state => state.singleClient.updateSale.status)
	const updateSaleError = useSelector(state => state.singleClient.updateSale.error)

	const fetchError = useSelector(state => state.singleClient.fetchDetails.error)
	const fetchLoading = useSelector(state => state.singleClient.fetchDetails.loading)

	const flushDetails = () => {
		dispatch(resetSingleClientDetails())
		dispatch(resetUpdateSingleClientData())
		dispatch(resetDeleteSingleClientData())
		dispatch(resetDeleteSingleClientSale())
		dispatch(resetSingleClientActiveSalesKey())
		dispatch(resetUpdateSingleClientSale())
		dispatch(resetSingleClientActiveSale())
		dispatch(resetAddSingleClientNote())
		dispatch(resetDeleteSingleClientNote())
	}

	useEffect(() => {
		flushDetails()
	}, [])

	useEffect(() => {
		if(updateStatus){
			sendSuccessNotification("Kunden ble oppdatert.")
			dispatch(resetUpdateSingleClientData())
			dispatch(retrieveSingleClientDetails({companyId: selectedCompany, clientId: clientId}))
		}
	
		if(updateError){
			sendErrorNotification("Kunne ikke oppdatere kunde.")
			dispatch(resetUpdateSingleClientData())
			dispatch(retrieveSingleClientDetails({companyId: selectedCompany, clientId: clientId}))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [updateStatus, updateError])

	useEffect(() => {
		if(deleteStatus){
			dispatch(resetDeleteSingleClientData())
			dispatch(setFallbackMessage({type: "success", content: "Kunden ble slettet."}))
			props.history.push("/dashboard/kunder")
		}

		if(deleteError){
			sendErrorNotification("Kunne ikke slette kunde.")
			dispatch(resetDeleteSingleClientData())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [deleteStatus, deleteError])

	useEffect(() => {
		if(addNoteError){
			sendErrorNotification("Kunne ikke legge til notat.")
			dispatch(resetAddSingleClientNote())
		}

		if(addNoteStatus){
			dispatch(retrieveSingleClientNotes({companyId: selectedCompany, clientId: clientId}))
			dispatch(resetAddSingleClientNote())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [addNoteStatus, addNoteError])

	useEffect(() => {
		if(deleteNoteError){
			dispatch(resetDeleteSingleClientNote())
			sendErrorNotification("Kunne ikke slette notat.")
		}

		if(deleteNoteStatus){
			dispatch(resetDeleteSingleClientNote())
			dispatch(retrieveSingleClientNotes({companyId: selectedCompany, clientId: clientId}))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [deleteNoteStatus, deleteNoteError])

	useEffect(() => {
        if(addSaleError){
            sendErrorNotification("Kunne ikke legge til salg.")
            dispatch(resetAddSingleClientSale())
            dispatch(retrieveSingleClientSales({companyId: selectedCompany, clientId: clientId, year: activeSelectionYear}))
        }

        if(addSaleStatus){
            sendSuccessNotification("Salget ble lagt til.")
            dispatch(resetAddSingleClientSale())
            dispatch(retrieveSingleClientSales({companyId: selectedCompany, clientId: clientId, year: activeSelectionYear}))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addSaleError, addSaleStatus])

	useEffect(() => {
        if(deleteSaleStatus){
            sendSuccessNotification("Salget ble slettet.")
            dispatch(resetSingleClientActiveSalesKey())
            dispatch(retrieveSingleClientSales({companyId: selectedCompany, clientId: clientId, year: activeSelectionYear}))
        }

        if(deleteSaleError){
            sendErrorNotification("Kunne ikke slette salg.")
            dispatch(resetDeleteSingleClientSale())
            dispatch(resetSingleClientActiveSalesKey())
			dispatch(retrieveSingleClientSales({companyId: selectedCompany, clientId: clientId, year: activeSelectionYear}))
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleteSaleStatus, deleteSaleError])

	useEffect(() => {
        if(updateSaleStatus){
            sendSuccessNotification("Salget ble oppdatert.")
			dispatch(retrieveSingleClientSales({companyId: selectedCompany, clientId: clientId, year: activeSelectionYear}))
            dispatch(resetSingleClientActiveSale())
            dispatch(resetUpdateSingleClientSale())
        }

        if(updateSaleError){
            sendErrorNotification("Kunne ikke oppdatere salg.")
            dispatch(resetSingleClientActiveSale())
            dispatch(resetUpdateSingleClientSale())
			dispatch(retrieveSingleClientSales({companyId: selectedCompany, clientId: clientId, year: activeSelectionYear}))
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateSaleStatus, updateSaleError])

	useEffect(() => {
		if(clientId && selectedCompany){
			dispatch(retrieveSingleClientDetails({companyId: selectedCompany, clientId: clientId}))
			dispatch(retrieveSingleClientRoles({companyId: selectedCompany, clientId: clientId}))
			dispatch(retrieveSingleClientNotes({companyId: selectedCompany, clientId: clientId}))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [clientId, selectedCompany])

	useEffect(() => {
		if(!fetchLoading && fetchError){
			flushDetails()
			history.push('/dashboard/kunder')
		}
	}, [fetchError])


	return(
		<section className="dashboard-single-client-section">
			<div className="inner-dashboard-single-client-container">
				<Row className="dashboard-single-client-row">
					<ClientInformation/>
					<ClientActivity/>
					{modalState.removeModal ? <DashboardSingleClientRemoveModal/>:null}
					{modalState.editModal ? <DashboardSingleClientEditModal/>:null}
					{modalState.saleModal ? <DashboardSingleClientNewSaleModal/>:null}
					{modalState.removeSaleModal ? <DashboardSingleClientRemoveSaleModal/>:null}
					{modalState.editSaleModal ? <DashboardSingleClientEditSaleModal/>:null}
				</Row>
			</div>
			<ToastContainer/>
		</section>
	)
}

export default withRouter(Index);
